import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-image-icon",
  "use": "icon-image-icon-usage",
  "viewBox": "0 0 16.039 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.039 16\" id=\"icon-image-icon\">\n  <g id=\"icon-image-icon_Image_Icon_\" data-name=\"Image Icon \" transform=\"translate(-12356.48 -2104.601)\">\n    <path id=\"icon-image-icon_Path_299\" data-name=\"Path 299\" d=\"M1061.98,151.6h16.04V140.4h-16.04Zm1.44-9.857h13.16v8.513h-13.16Z\" transform=\"translate(11294.5 1969)\" fill=\"#505050\" />\n    <path id=\"icon-image-icon_Path_300\" data-name=\"Path 300\" d=\"M1063.18,138h13.64v1.44h-13.64Z\" transform=\"translate(11294.5 1969)\" fill=\"#505050\" />\n    <path id=\"icon-image-icon_Path_301\" data-name=\"Path 301\" d=\"M1064.38,135.6h11.24v1.44h-11.24Z\" transform=\"translate(11294.5 1969)\" fill=\"#505050\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/image-icon.svg
// module id = 139
// module chunks = 0 1 2